import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LoHiLoadsListItem } from '../types';

@Pipe({
  name: 'inProgressLoadByPhone',
})
export class InProgressLoadByPhonePipe implements PipeTransform {
  constructor() {}

  // tslint:disable-next-line
  public transform(phoneNumber: string): Observable<LoHiLoadsListItem> {
    return of({} as LoHiLoadsListItem);
  }
}
